import { drawingEvents } from './constants';

export const drawingEventsSet = (events) => ({
  type: drawingEvents.SET,
  events,
});
